import { KineticText } from "./KineticText";

export const ChapterHeading = ({ num, label, title, testId }) => (
  <div className="grid grid-cols-12 gap-6 items-end" data-testid={testId}>
    <div className="col-span-12 md:col-span-3 flex items-center gap-4">
      <span className="eyebrow">[ {num} ]</span>
      <span className="eyebrow !text-[var(--accent)]">{label}</span>
    </div>
    <div className="col-span-12 md:col-span-9">
      <KineticText
        as="h2"
        lines={Array.isArray(title) ? title : [title]}
        className="font-display uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl"
      />
    </div>
  </div>
);
